//--- Used on mobile only, add an overlay on top of the map
const OverlayHeader = ({ title, setMapScreen, setFilterScreen, setSelectedInstitution }) => {
  
  const closeMapScreen = () => {
    document.body.classList.remove("no-scroll");
    setMapScreen(false);
    setSelectedInstitution("");
  };

  const openFilterScreen = () => {
    document.body.classList.add("no-scroll");
    setFilterScreen(true);
  };

  return (
    <div className="map__wrapper--title">
      <h3 className="sidebar__title">{title}</h3>
      <div>
        <button className="map__wrapper--button" onClick={() => openFilterScreen()}>
          <span className="icon iconReactLeafletfilter"></span>
          Filtres
        </button>
      </div>
    </div>
  );
};

export default OverlayHeader;
